import { useTranslation } from "react-i18next";
import Error from "../Error.svg";
import SuccessScreen from "../lib/SuccessScreen";

type Props = {
  logout: () => void;
};

// Shown when completing a first-time SSO registration fails (e.g. this email
// is already linked to a different identity). Every route waits on
// registration, so the way out is a logout rather than a link.
export default function RegistrationFailedScreen({ logout }: Props) {
  const { t } = useTranslation();

  return (
    <SuccessScreen
      illustration={Error}
      illustrationWidth={257}
      title={t("We couldn't finish setting up your account")}
      content={t("Please try signing in again or contact support.")}
      buttonText={t("Return to sign in")}
      onClick={logout}
    />
  );
}
